import { createSelector } from '@reduxjs/toolkit';
import type { ProfileTypeCategory } from '@shared/schemas';

import type { RootState } from '@/store/root-reducer';

import type { ProfileTypeBlock } from '../domain/profile-type.model';

const selectState = (state: RootState) => state.profileTypes;

export const selectBlocks = (state: RootState) => selectState(state).blocks;
export const selectLoadStatus = (state: RootState) => selectState(state).loadStatus;
export const selectSaving = (state: RootState) => selectState(state).saving;
export const selectClearingName = (state: RootState) => selectState(state).clearingName;
export const selectTogglingNames = (state: RootState) => selectState(state).togglingNames;
export const selectRunningName = (state: RootState) => selectState(state).runningName;
export const selectRunPreview = (state: RootState) => selectState(state).runPreview;
export const selectDraftPreview = (state: RootState) => selectState(state).draftPreview;
export const selectNotice = (state: RootState) => selectState(state).notice;
export const selectStats = (state: RootState) => selectState(state).stats;
export const selectApplyTarget = (state: RootState) => selectState(state).applyTarget;
export const selectRemoval = (state: RootState) => selectState(state).removal;
export const selectRemovals = (state: RootState) => selectState(state).removals;
export const selectUndoingId = (state: RootState) => selectState(state).undoingId;

export interface TypeGroup {
  category: ProfileTypeCategory | null;
  types: ProfileTypeBlock[];
}

/**
 * The overview's groups: HNWI, then Institutionals, then the types nobody has filed
 * yet; last, because they are the ones left to do, not the ones to read first.
 * Empty groups are dropped. Inside a group, the server's priority order is kept.
 */
export const selectTypeGroups = createSelector(selectBlocks, (blocks): TypeGroup[] =>
  ([['HNWI'], ['Institutionals'], [null]] as [ProfileTypeCategory | null][])
    .map(([category]) => ({ category, types: blocks.filter((b) => b.category === category) }))
    .filter((g) => g.types.length > 0),
);

/** The Priority tab's working order and its lifecycle (#554). */
export const selectTypePriority = (state: RootState) => selectState(state).typePriority;
